export default __webpack_public_path__ + "static/media/exterior-3.de1db89c.webp";